import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEntubaBCheckResponse } from '../interface/entuba/bcheck/IEntubaBCheckResponse';
import { IEntubaBCheckDetailResponse } from '../interface/entuba/bcheck/IEntubaBCheckDetailResponse';
import { IEntubaCedenteCotaRequest } from '../interface/entuba/bcheck/IEntubaBCheckRequest';
import { IEntubaFomalizationPerExtractRequest } from "../interface/entuba/FormalizatioExtract/IEntubaFomalizationPerExtractRequest";
import { IEntubaUpdateQuotaPostPurchaseRequest } from "../interface/entuba/IEntubaUpdateQuotaPostPurchaseRequest";
import { IEntubaUpdateDataQuotaPostPurchaseResponse } from "../interface/entuba/IEntubaUpdateDataQuotaPostPurchaseResponse";
import { IEntubaUpdateTradePricingRequest } from "../interface/entuba/IEntubaUpdateTradePricingRequest";
import { IEntubaUpdateTradePricingResponse } from "../interface/entuba/IEntubaUpdateTradePricingResponse";

enum EntubaCedenteCotaServiceEnum {
  base = "/",
  start = "/start",
  startEntubaQuotaPostPurchase = "/quota/postPurchase/start",
  getAllEntubaQuotaPostPurchase = "/quota/postPurchase",
  startEntubaFormalizationExtract = "/formalization/extract",
  getAllTypeUpdateDataQuotaPostPurchaseEnum = "/quota/postPurchase/label/types",
  startEntubaUpdateTradePricing = "/trade/pricing/start",
  getAllEntubaUpdateTradePricing = "/trade/pricing/"
}

export default class EntubaCedenteCotaService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/entuba");
  }
  public getAll = async (): Promise<IEntubaBCheckResponse[]> => await this.GET(EntubaCedenteCotaServiceEnum.base);
  public getAllTypeUpdateDataQuotaPostPurchaseEnum = async () => await this.GET(EntubaCedenteCotaServiceEnum.getAllTypeUpdateDataQuotaPostPurchaseEnum);
  public getEntubaQuotaPostPurchaseAll = async (): Promise<IEntubaUpdateDataQuotaPostPurchaseResponse[]> => await this.GET(EntubaCedenteCotaServiceEnum.getAllEntubaQuotaPostPurchase);
  public getDetail = async (id: number): Promise<IEntubaBCheckDetailResponse> => await this.GET(`${EntubaCedenteCotaServiceEnum.base}${id}`);
  public start = async (data: IEntubaCedenteCotaRequest) => await this.PUT(EntubaCedenteCotaServiceEnum.start, data);
  public startEntubaQuotaPostPurchase = async (data: IEntubaUpdateQuotaPostPurchaseRequest) => await this.PUT(EntubaCedenteCotaServiceEnum.startEntubaQuotaPostPurchase, data);
  public startEntubaFormalizationExtract = async (data: IEntubaFomalizationPerExtractRequest) => await this.PUT(EntubaCedenteCotaServiceEnum.startEntubaFormalizationExtract, data);
  public startEntubaUpdateTradePricing = async (data: IEntubaUpdateTradePricingRequest) => await this.PUT(EntubaCedenteCotaServiceEnum.startEntubaUpdateTradePricing, data);
  public getAllEntubaUpdateTradePricing = async (): Promise<IEntubaUpdateTradePricingResponse[]> => await this.GET(EntubaCedenteCotaServiceEnum.getAllEntubaUpdateTradePricing);
}



// WEBPACK FOOTER //
// ./src/services/api/EntubaCedenteCota.service.ts